const isWorkhaus =
  process.env.GATSBY_CLIENT_UUID === "2f33867f-cd37-4778-9daa-a07836ebd907"

export default isWorkhaus
